export default "__VITE_ASSET__DSYTcY5k__"